import { RootState } from 'reduxStore/types';

export const getExecutorNavigation = (state: RootState) =>
  state?.moderationRequest.isNavigateDisabled;
